/**
 * dev:dev环境
 * sit:sit环境
 * product:正式上线环境
 * 
 */
let environment = 'robby-dev';

function getBaseUrl() {
	return 'https://panel.docnet.asia';
	switch (environment) {
		case 'dev':
			return 'http://api-dev.healshealthcare.com/api';
		case 'sit':
			return 'https://api-sit.healshealthcare.com/api';
		case 'product':
			return 'https://api.healshealthcare.com/api';
		case 'debug':
			return 'http://42.192.199.199/api';
		case 'csx-dev':
			return 'https://api-gateway-dev.heals.asia';
		case 'robby-dev':
			return 'http://116.205.131.126';
		default:
			return '';
	}
}

module.exports = {
	getBaseUrl
};



//////////////////
// WEBPACK FOOTER
// ./heals-config.js
// module id = asyg
// module chunks = 1